import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-product-display-zone-list',
  templateUrl: './product-display-zone-list.component.html',
  styleUrls: ['./product-display-zone-list.component.css']
})
export class ProductDisplayZoneListComponent implements OnInit {

  productDisplayZoneList: any= []
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  singleProductDisplayZoneData: any= []
  deleteProductDisplayZoneId: any
  first: number = 0;
  isLoading: any = false

  actionControls: any = {
    isAdd: false, 
    isView: false, 
    isDelete: false, 
    isModify: false 
  }

  constructor(
    private generic_service: GenericService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    let href:any = window.location.href;
    let messages = href.split('/') 
    let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
    this.actionControls = action

    this.getAllProductDisplayZone();
  }

  onTableDataChange(event: any) {
    this.page = event.page+1;
  }

  getAllProductDisplayZone(){
    this.generic_service.getAllProductDisplayZone().subscribe(
      (response:any)=>{
        console.log(response);
        this.productDisplayZoneList = response.response
        this.count = response.response.length
      }
    )
  }

  getProductDisplayZoneById(productDisplayZoneById:any){
    this.generic_service.getProductDisplayZoneById(productDisplayZoneById).subscribe(
      (res:any)=>{
        console.log(res)
        this.singleProductDisplayZoneData.push(res.response)
      },
      (err:any)=> {
        console.log(err)
      }
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
    document.getElementById("closeModalButton3")?.click()
  }

  selectProductDisplayZone(id:any){
    this.deleteProductDisplayZoneId = id
  }

  deleteProductDisplayZoneById(){
    this.generic_service.deleteProductDisplayZone(this.deleteProductDisplayZoneId).subscribe(
      (res:any)=>{
        console.log(res)
        this.getAllProductDisplayZone()
        this.toastr.success("Successfully Deleted")
        this.cancelModel()
      },
      (err:any)=> {
        console.log(err)
        this.toastr.error(err.errors[0].description)
      }
    )
  }

}

